var exports = {
  "k": "container__RmBx4A",
};

module.exports = exports;
